<template>
    <!-- <component v-bind:is="layout"></component> -->
  <v-overlay :value="loading" v-if="loading">
    <v-progress-circular
      indeterminate
      size="64"
      color="accent"
    ></v-progress-circular>
  </v-overlay>
  <router-view v-else>

  </router-view>

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "App",
  computed: {
    ...mapState('auth', ['loading']),
  },
  mounted() {
    localStorage.setItem('authLogControl', false);
  },
  components: {
  }
};

</script>

<style>
html,
body,
#app {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  -webkit-text-size-adjust: 100%;
}

@media (max-width: 767px) {
  input,
  select,
  textarea,
  .form-control,
  .form-control-sm,
  .custom-select,
  .generic-login__input,
  .agreement-modal__input {
    font-size: 16px !important;
  }
}
</style>

